export function branchMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      branchId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateBranchId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateBranchId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function branchMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, branchId: json.result.objectId},
  };
}